var map = {
	"./list-img0.jpg": "eREi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wFsr";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/list\-img.*\.jpg$
// module id = wFsr
// module chunks = 1